module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-hero3.png?5e15e74a";